import createCache from '@emotion/cache'
import { prefixer } from 'stylis'
import rtlPlugin from 'stylis-plugin-rtl'

// Create an Emotion cache instance configured for RTL
export default function createEmotionRtlCache() {
  return createCache({
    key: 'mui-rtl',
    stylisPlugins: [prefixer, rtlPlugin],
  })
}
